import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsNeededZIndex } from '../../../../../redux/selector/system'
import KeyBindings from '../../../keybindings'
import CustomModal from '../../CustomModal'
import Order from '../Order'
import Button from '../../../buttons/Button'
import { useTranslation } from 'react-i18next'
import { ButtonsWrap } from './index.styled'
import { printRequestsThunk } from '../../../../../redux/thunk/order/printRequests'

const EVENT_Z_INDEX = 14

const OrderDataModal = React.memo(({ order, modalIsOpen, close }) => {
	const isNeededZIndex = useSelector(selectIsNeededZIndex(EVENT_Z_INDEX))
	const dispatch = useDispatch()
	const { t } = useTranslation()
	const isDeliveryByPlatform = order?.orderType === 'DELIVERY_BY_PLATFORM'
	const updatedDeliveryByPlatform = !!(order?.orderType === 'DELIVERY' && order?.deliveryMetaData?.partner?.type)
	const isPlatformDriverOrder = isDeliveryByPlatform || updatedDeliveryByPlatform
	const isOrderOfGiftCoupon = order?.items?.[0]?.type === 'GIFT_COUPON'
	const title = (isOrderOfGiftCoupon ? t('Cart.GiftVoucher.title') : isPlatformDriverOrder ? t('Filter.type.DELIVERY') : t(`Filter.type.${order?.orderType}`))
	const isPaid = order?.payments?.filter(item => item?.method === order?.paymentMethod)[0]?.payed
	const isRestaurant = order?.orderType === 'RESTAURANT'

	const showPrintButton = useMemo(() => {
		if (!order) return false
		return !['NOT_ACCEPTED', 'DENIED', 'NOT_REGISTERED', 'ABORTED'].includes(order.status?.status)
	}, [order])

	const handlePrintOrder = useCallback(async () => {
		if (!order.orderId) return
		if (isPaid) {
			await dispatch(printRequestsThunk(order.orderId, 'CUSTOMER_RECEIPT_DUPLICATE', false))
			await dispatch(printRequestsThunk(order.orderId, 'KITCHEN_RECEIPT'))
		} else {
			dispatch(printRequestsThunk(order.orderId, 'PRELIMINARY_RECEIPT'))
		}
	}, [dispatch, order?.orderId, isPaid])

	return (
		<>
			<CustomModal isOpen={modalIsOpen}
									 id="order-data-modal"
									 close={close}
									 title={title}
									 zIndex={EVENT_Z_INDEX}
									 returnZIndex={1}
									 titleUpperCase={true}
									 disableBackButton={true}
									 size={'height-scroll ' + (isRestaurant ? 's-medium' : 'small')}
									 button={
										 <ButtonsWrap>
											 <Button icon="clear" keyButton="F3" text={t('buttons.controls.cancel_1')} onClick={close} className="back" />
											 {showPrintButton &&
												 <Button name="print" icon="print" text={t('order.modal.print_order')} color="green"
																 keyButton="F2" zIndex={EVENT_Z_INDEX} onClick={handlePrintOrder} />}
										 </ButtonsWrap>
									 }>
				{order && <Order order={order} />}
			</CustomModal>

			{isNeededZIndex &&
				<KeyBindings escape={close} />}
		</>
	)
})

OrderDataModal.displayName = 'OrderDataModal'
export default OrderDataModal
